<template lang="pug">
.box-public-qa
    .container
        .box-public-top  
            span.beehive 
                img(src="../../../../assets/images/home/ic_mark_hoidap.png")
            .title {{$t("home.qa.title")}}
            a.view-more(@click="onPublicQA") {{$t("home.view_more")}} >>
        .box-public-content
            .row
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
                .col-md-4.col-sm-6.col-xs-12.box-parent-public
                    .box-item-public(@click="onPublicOne")
                        img(src="../../../../assets/Obee_Logo_140@2x.png")
            .clearfix
            a.view-more.mobile(@click="onPublicQA") {{$t("home.view_more")}} >>
    .clearfix
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import store from '../../../../store'
export default {
  components: {
    MdNotification,
    store
  },
  data() {
    return {
      message: this.$t('home.comming_soon')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    onPublicQA() {
      this.showNotification(this.message, 'warning', 'top', 'right', 5000)
    },
    onPublicOne() {
      this.showNotification(this.message, 'warning', 'top', 'right', 5000)
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  apollo: {
    // lstLessons: {
    //   query: gql(graphql.GET_LESSONS_HOME),
    //   variables: {
    //     limit: 6,
    //     type_lesson: 1
    //   },
    //   update: data => {
    //     console.log('============= lesson', data.v_front_lesson)
    //     return data.v_front_lesson
    //   }
    // }
  }
}
</script>
<style lang="scss">
.content.front{
    .box-public-qa{margin-top:80px;margin-bottom:0px;
        .box-public-top{margin-bottom: 20px;
            .title{text-align: left;font-weight: bold; font-size: 25px;letter-spacing: 0px;color: #23180A;text-transform: uppercase; display: inline-block}
            .view-more{cursor: pointer; display: inline-block; float:right;color: #1A0DAB; font-size:15px; margin-top:5px;}
            .view-more.mobile{display: none;}
        }
        .box-public-content{
            .box-item-public{cursor: pointer; box-shadow: 0px 5px 5px #00000029;margin-bottom:30px;border: 1px solid #ccc;height: 191px; overflow: hidden;display:flex;justify-content: center;align-items:center;
                img{max-width: 100%; height: 100%; object-fit: contain;}
            }
            .view-more.mobile{display: none;color: #1A0DAB;}
        }
    }
}
@media (max-width: 1366px){
    .content.front{
        .box-public-qa{
            .box-public-content{
                .view-more.mobile{ display: none;}
                .box-parent-public{
                    // .box-item-public{height: 150px;}
                }
            }
        }
    }
}
@media (max-width: 1024px){
    .content.front{
        .box-public-qa{
            .box-public-content{
                .view-more.mobile{ display: none;}
            }
        }
    }
}
@media (max-width: 991px){
    .content.front{
        .box-public-qa{
            .box-public-top{
                // .view-more{display: none;}
            }
            .box-public-content{
                // .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-public{width: 50%;
                    .box-item-public{height: 170px;}
                }
            }
        }
    }
}
@media (max-width: 768px){
    .content.front{
        .box-public-qa{margin-top: 45px;
            .box-public-top{
                .title{font-size:20px;}
                // .view-more{display: none;}
            }
            .box-public-content{
                // .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
            }
        }
    }
}
@media (max-width: 560px){
    .content.front{
        .box-public-qa{margin-top: 45px;
            .box-public-top{
                .title{font-size:18px;}
                .view-more{display: none;}
            }
            .box-public-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-public{width: 100% !important;
                    .box-item-public{height: 150px;}
                }
            }
        }
    }
}
@media (max-width: 375px){
    .content.front{
        .box-public-qa{margin-top: 45px;
            .box-public-top{
                .title{font-size:18px;}
                .view-more{display: none;}
            }
            .box-public-content{
                .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
                .box-parent-public{width: 100%;
                    .box-item-public{height: 150px;}
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// index.vue?7602bbb8